<template>
    <div>
        <div class="sub_title mb15">
            스마트 피팅 등록
            <div class="fs12 pt5">
                상태안내: 등록대기 = 미등록 | 등록중 = 스마트 피팅 합성중 | 등록완료 = 스미트 피팅 합성 완료 <br>
                등록완료의 경우에만 앱단에서 노출됩니다.
            </div>
        </div>
        <div class="table_wrap">
            <div class="el-table el-table--fit el-table--enable-row-hover">
                <div class="el-table__header-wrapper">
                    <table class="el-table__header el-table__body wp100">
                        <colgroup>
                            <col name="el-table_8_column_59" width="auto">
                            <col name="el-table_8_column_60" width="auto">
                            <col name="el-table_8_column_61" width="auto">
                            <col name="el-table_8_column_62" width="200">
                            <col name="gutter" width="0">
                        </colgroup>
                        <thead class="has-gutter">
                        <th class="el-table_8_column_59 text_center  is-leaf">
                            <div class="cell">성별 구분</div>
                        </th>
                        <th class="el-table_8_column_60 text_center  is-leaf">
                            <div class="cell">상태</div>
                        </th>
                        <th class="el-table_8_column_61 text_center  is-leaf">
                            <div class="cell">등록 상품 개수</div>
                        </th>
                        <th class="el-table_8_column_62 text_center  is-leaf">
                            <div class="cell">옵션</div>
                        </th>

                        </thead>
                        <tr class="el-table__row">
                            <td class="el-table_8_column_59 text_center">
                                <div class="cell"> {{ returnFittingGender() }}</div>
                            </td>
                            <td class="el-table_8_column_60 text_center">
                                <div class="cell">{{
                                        getFittingStatus(fittingData.fittingStatus)
                                    }}
                                </div>
                            </td>
                            <td class="el-table_8_column_61 text_center">
                                <div class="cell">{{ returnFittingItemsName() }}</div>
                            </td>
                            <td class="el-table_8_column_62 is-center table_bottons">
                                <div class="cell">
                                    <el-button
                                        size="mini"
                                        :type="!hasFittingData() ? 'primary' : 'warning'"
                                        @click="openFittingModal()">
                                        {{ !hasFittingData() ? '등록' : '상세' }}
                                    </el-button>
                                    <el-button
                                        v-if="fittingData.fittingStatus == 1"
                                        size="mini"
                                        type="danger"
                                        @click="openDeleteConfirm()"
                                    >
                                        삭제
                                    </el-button>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "../../mixins/event-bus";
import smartFittingMixins from "@/mixins/smartFittingMixins";

export default {
    name: "StyleFittingComponent",
    mixins: [alertMixins, smartFittingMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        styleKey: {},
    },
    data() {
        return {
            styleData: {},
            fittingData: {
                fittingPartCount: 0,
                fittingPose: 1, // 피팅포즈
                fittingGender: 2, //피팅 성별
                fittingIdx: null,
                fittingItems: {},
                fittingStatus: 4,
            },
        }
    },
    created() {
        this.getStyleData();
        this.getFittingData();
    },
    mounted() {
        EventBus.$on('runSelectFitting', this.runSelectFitting);
    },
    beforeDestroy() {
        EventBus.$off('runSelectFitting');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        _getFittingDefaultData() {
            return {
                fittingPartCount: 0,
                fittingPose: 1, // 피팅포즈
                fittingGender: 2, //피팅 성별
                fittingIdx: null,
                fittingItems: {},
                fittingStatus: 4,
            };
        },
        getStyleData() {
            this.$api.$style.getStyleList({eid: this.styleKey}).then(res => res.Data.Result).then(res => {
                if (util.isEmpty(res.List)) {
                    return false;
                }
                this.styleData = res.List[0];
            })
        },
        getFittingData() {
            let params = {ty: 'home', es: this.styleKey,};
            this.$api.$style.getFittingData(params).then(res => res.Data.Result).then(res => {
                if (!util.isEmpty(res.List)) {
                    let recommend = res.List[0];
                    this.fittingData.fittingGender = recommend.vf_gender;
                    this.fittingData.fittingPose = recommend.vf_pose;
                    this.fittingData.fittingPartCount = recommend.Items.length;
                    this.fittingData.fittingIdx = recommend.vf_idx;
                    this.fittingData.fittingStatus = recommend.vf_status;
                    util.Array.each(recommend.Items, (value, index, obj) => {
                        this.fittingData.fittingItems[value.vfi_part] = {
                            i_idx: value.i_idx,
                            info: {
                                type: value.vfi_part,
                                i_idx: value.i_idx,
                                itemImage: value.File.slice(),
                                i_name: value.i_name,
                                i_price: value.i_price,
                                i_model: value.i_model,
                                i_display: value.i_display
                            }
                        }
                    })
                }
            })
        },
        hasFittingData() {
            return !util.isEmpty(this.fittingData.fittingIdx)
        },
        returnFittingGender() {
            let text = '-';
            if (!this.hasFittingData()) {
                return text
            }
            switch (this.fittingData.fittingGender) {
                case 0:
                    return '남성';
                case 1:
                    return '여성'
                case 2:
                    return '공용';
                default:
                    return '-';
            }
        },
        returnFittingItemsName() {
            if (!this.fittingData.fittingPartCount || this.fittingData.fittingPartCount <= 0) {
                return '미등록'
            }
            return this.fittingData.fittingPartCount + '개';
        },
        openFittingModal() {
            let depth1Cate = this.styleData.ic_idx;
            let fitData = JSON.parse(JSON.stringify(this.fittingData));
            let defaultGender = this.styleData.es_gender == 1 ? 0 : 1;
            let disabledGender = [];
            if(this.styleData.es_gender == 1) { //남성
                disabledGender.push(1)
            }else { //여성
                disabledGender.push(0)
            }

            this.$modal.show('magazine-fitting-edit-modal', {
                fittingData: fitData,
                depth1Cate: depth1Cate,
                showGender: false,
                defaultGender: defaultGender,
                isSaveClose: false,
            });
        },
        runSelectFitting(fitData) {
            let params = {
                vf_type: 'home',
                es_idx: this.styleKey,
                vf_gender: fitData.fittingGender,
                vf_pose: fitData.fittingPose,
                item: {},
            }
            util.Object.each(fitData.fittingItems, (key, value, obj) => {
                params.item[key] = value.i_idx;
            })
            EventBus.$emit('apiLoading', true);
            this.$api.$style.createFittingData(params).then(res => res.Data.Result).then(res => {
                EventBus.$emit('apiLoading', false);
                if(res.Info.Type === 1) {
                    this.fittingData = this._getFittingDefaultData();
                    this.getFittingData();
                    this.$modal.hide('magazine-fitting-edit-modal');
                    this.createAlert({
                        content: '등록되었습니다.',
                    });
                }else{
                    this.errorAlert('등록에 실패하였습니다.');
                }
            })
        },
        openDeleteConfirm() {
            this.createConfirm({
                content: '삭제하시겠습니까?',
                confirm: this.deleteFittingData,
            })
        },
        deleteFittingData() {
            let params = {
                vf_idx: this.fittingData.fittingIdx,
            }
            EventBus.$emit('apiLoading', true);
            this.$api.$style.deleteFittingData(params).then(res => res.Data.Result).then(res => {
                EventBus.$emit('apiLoading', false);
                if(res.Info.Type == 1) {
                    this.createAlert({
                        content: "삭제되었습니다.",
                    })
                    this.fittingData = this._getFittingDefaultData(params)
                }else {
                    this.errorAlert('삭제에 실패하였습니다.');
                }
            });
        },
    },
}
</script>

<style scoped>

</style>
